// スクロール時にanmクラスにshowを付与
$(function(){
    //anm
    var scrollAnimationElm = document.querySelectorAll('.anm');
    var scrollAnimationFunc = function() {
      for(var i = 0; i < scrollAnimationElm.length; i++) {
        var triggerMargin = 300;
        if (window.innerHeight > scrollAnimationElm[i].getBoundingClientRect().top + triggerMargin) {
          scrollAnimationElm[i].classList.add('show');
        }
      }
    }
    window.addEventListener('load', scrollAnimationFunc);
    window.addEventListener('scroll', scrollAnimationFunc);
  });
  
  $(function(){
    //js-fadeIn
    var scrollAnimationElm = document.querySelectorAll('.js-fadeIn, .js-slideIn1, .js-slideIn2');
    var scrollAnimationFunc = function() {
      for(var i = 0; i < scrollAnimationElm.length; i++) {
        var triggerMargin = 300;
        if (window.innerHeight > scrollAnimationElm[i].getBoundingClientRect().top + triggerMargin) {
          scrollAnimationElm[i].classList.add('js-show');
        }
      }
    }
    window.addEventListener('load', scrollAnimationFunc);
    window.addEventListener('scroll', scrollAnimationFunc);
  });